import { Component, OnDestroy, TemplateRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/services';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnDestroy {

  toasts: any[] = [];

  private subscription: Subscription = new Subscription();

  constructor(
    private notification: NotificationService
  ) {

    this.toasts = this.notification.getToasts();

    this.subscription.add(
      this.notification.toastsChanged.subscribe(list => {

        this.toasts = list;
        this.scheduleAutoHide();
      })
    );

    this.scheduleAutoHide();
  }

  ngOnDestroy(): void {

    this.subscription.unsubscribe();
  }


  /**
   *
   * @param toast any
   */
  removeToast(toast: any): void {

    this.notification.remove(toast);
  }


  /**
   *
   * @param toast any
   * @returns boolean
   */
  isTemplate(toast: any): boolean {

    return toast.textOrTpl instanceof TemplateRef;
  }


  /**
   * Запускаем автоскрытие для тостов, у которых ещё не запущен таймер.
   */
  private scheduleAutoHide(): void {

    this.toasts.forEach(toast => {

      if (toast._hideTimeoutId) return;

      const delay: number = toast.delay || 5000;

      toast._hideTimeoutId = setTimeout(() => {

        this.notification.remove(toast);
      }, delay);
    });
  }
}
